import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"

export const StyledPercentageInput = styled.input`
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;

  // Hide browser number input controls
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type="number"] {
    -moz-appearance: textfield;
  }
`

export const PercentageInputContainer = styled(FlexContainer)`
  width: 100%;
  padding: 10px 25px 10px 10px;
`

export const PercentageSuffix = styled.span`
  pointer-events: none;
`
